import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { type MenuItemType } from '@/menu/webMenu';
import { type Permission, type User } from '@packages/types/auth';
import { buildMenuTree, derivePolicyFromUser } from './menuPolicy';

interface PolicyState {
  permissions: Permission | null;
  menuTree: MenuItemType[];
  isSuperAdmin: boolean;
  setPolicyFromUser: (user: User | null) => void;
  reset: () => void;
}

const buildInitialMenuTree = () =>
  buildMenuTree({ isAuthenticated: false, permissions: null, isSuperAdmin: false });

export const usePolicyStore = create<PolicyState>()(
  persist(
    set => ({
      permissions: null,
      menuTree: buildInitialMenuTree(),
      isSuperAdmin: false,

      setPolicyFromUser: (user: User | null) => {
        const { isAuthenticated, permissions, isSuperAdmin } = derivePolicyFromUser(user);
        const menuTree = buildMenuTree({ isAuthenticated, permissions, isSuperAdmin });
        set({ permissions, isSuperAdmin, menuTree });
      },

      reset: () => {
        const initialMenu = buildInitialMenuTree();
        set({ permissions: null, menuTree: initialMenu, isSuperAdmin: false });
      },
    }),
    {
      name: 'policy-storage',
      partialize: state => ({
        permissions: state.permissions,
        menuTree: state.menuTree,
        isSuperAdmin: state.isSuperAdmin,
      }),
    }
  )
);
